import { AlertTriangle, TrendingDown, BarChart3 } from 'lucide-react';
import { Card } from '../common';
import type { GapsSummary } from '../../types';

interface GapSummaryCardsProps {
  summary: GapsSummary;
}

export function GapSummaryCards({ summary }: GapSummaryCardsProps) {
  const highPct = summary.total_gaps > 0
    ? Math.round((summary.by_severity.high / summary.total_gaps) * 100)
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card variant="metric">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-wolf-800 rounded-lg">
            <BarChart3 className="w-5 h-5 text-action" />
          </div>
          <div>
            <p className="text-sm text-wolf-400">Total Gaps</p>
            <p className="text-2xl font-bold text-white font-mono">
              {summary.total_gaps}
            </p>
          </div>
        </div>
      </Card>

      <Card variant="metric">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-900/30 rounded-lg">
            <AlertTriangle className="w-5 h-5 text-red-400" />
          </div>
          <div>
            <p className="text-sm text-wolf-400">High Severity</p>
            <p className="text-2xl font-bold text-white font-mono">
              {summary.by_severity.high}
              <span className="text-sm text-wolf-400 ml-1">({highPct}%)</span>
            </p>
          </div>
        </div>
      </Card>

      <Card variant="metric">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-wolf-800 rounded-lg">
            <TrendingDown className="w-5 h-5 text-yellow-400" />
          </div>
          <div>
            <p className="text-sm text-wolf-400">Medium / Low</p>
            <p className="text-2xl font-bold text-white font-mono">
              {summary.by_severity.medium} / {summary.by_severity.low}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
